import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import Seo from "../../components/Seo";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("aloha_admin_token", data.token);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-pine-dark px-4" data-testid="admin-login-page">
      <Seo title="Admin Login — Aloha Corfu Tours" description="Admin area of Aloha Corfu Tours." />
      <div className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-lift">
        <div className="mb-6 flex flex-col items-center text-center">
          <img src="/assets/aloha-logo.png" alt="Aloha Corfu Tours logo" className="h-14 w-14 rounded-full" />
          <h1 className="mt-3 font-display text-2xl font-semibold text-pine">Admin Panel</h1>
          <p className="mt-1 text-sm text-gray-500">Sign in to manage your website</p>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-gray-500" htmlFor="admin-username">Username</label>
            <input id="admin-username" autoComplete="username" data-testid="admin-username-input"
                   className="w-full rounded-lg border border-input px-3.5 py-2.5 text-sm outline-none focus:border-pine focus:ring-2 focus:ring-pine/15"
                   value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-gray-500" htmlFor="admin-password">Password</label>
            <input id="admin-password" type="password" autoComplete="current-password" data-testid="admin-password-input"
                   className="w-full rounded-lg border border-input px-3.5 py-2.5 text-sm outline-none focus:border-pine focus:ring-2 focus:ring-pine/15"
                   value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
                  className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-pine px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-pine-light disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
